export default defineNuxtPlugin((nuxtApp) => {
    const loggedErrors = new WeakSet<object>();

    function logError(error: unknown) {
        if (error && typeof error === "object") {
            if (loggedErrors.has(error)) return;
            loggedErrors.add(error);
        }

        console.error(
            "[Storefront error]",
            {
                path: nuxtApp.ssrContext?.url?.split("?")[0]
                    ?? nuxtApp.$router?.currentRoute.value.path
                    ?? "/",
            },
            error,
        );
    }

    nuxtApp.hook("vue:error", logError);
    nuxtApp.hook("app:error", logError);
    if (nuxtApp.payload?.error) logError(nuxtApp.payload.error);
});
